import { NumberUtils } from '@spotify/confidence-core-react';

export type ExperimentTreatment = Record<string, unknown> & {
  displayName?: string;
  name?: string;
  variant?: string;
  weight: unknown;
};

export type RawExperimentMetric = Record<string, unknown>;

export type ExperimentMetric = {
  metric: string;
  isGuardrail: boolean;
  direction?: string;
  mde?: number;
  nim?: number;
};

export const parseExperimentMetric = (
  raw: RawExperimentMetric,
): ExperimentMetric => {
  const metric = String(raw.metric ?? raw.name ?? '');
  const role = (raw.metricRole ?? raw.metric_role ?? {}) as Record<
    string,
    unknown
  >;
  const metricKind = String(role.metricKind ?? role.metric_kind ?? '');
  const direction = String(
    raw.preferredDirection ?? raw.preferred_direction ?? '',
  );
  const rawMde = role.minimumDetectableEffect ?? role.minimum_detectable_effect;
  const mde =
    rawMde !== undefined && rawMde !== null ? Number(rawMde) : undefined;
  const rawNim = role.nonInferiorityMargin ?? role.non_inferiority_margin;
  const nim =
    rawNim !== undefined && rawNim !== null ? Number(rawNim) : undefined;

  return {
    metric,
    isGuardrail: metricKind === 'GUARDRAIL',
    direction,
    mde,
    nim,
  };
};

export const formatMinimumDetectableEffect = (
  mde: number | undefined,
): string => {
  if (mde === undefined) return '';
  return `Detect changes ≥ ${NumberUtils.formatRatioAsPercentage(mde)}`;
};

export const formatNonInferiorityMargin = (nim: number | undefined): string => {
  if (nim === undefined) return '';
  return `Non-inferiority margin ${NumberUtils.formatRatioAsPercentage(nim)}`;
};

export const getExperimentMetricDirectionText = (
  direction: string | undefined,
  isGuardrail: boolean,
): string => {
  if (isGuardrail) {
    if (direction === 'INCREASE') return 'Must not decrease';
    if (direction === 'DECREASE') return 'Must not increase';
    return 'Must not change';
  }
  if (direction === 'INCREASE') return 'Should increase';
  if (direction === 'DECREASE') return 'Should decrease';
  return 'Any direction';
};
